import intlTelInput from 'intl-tel-input'

setTimeout(function () {
  (function (jQuery) {
    const input = document.querySelector('#phone')
    const formId = input.closest('form').id
    const areaCodeInput = document.querySelector(`#${formId}-areaCode`)
    // const iti = window.intlTelInputGlobals.getInstance(input)

    const iti = intlTelInput(input, {
      initialCountry: 'auto',
      separateDialCode: true,
      autoInsertDialCode: true,
      geoIpLookup: function (success, failure) {
        jQuery.get('https://ipinfo.io', function () {}, 'jsonp').always(function (resp) {
          var countryCode = (resp && resp.country) ? resp.country : 'us'
          success(countryCode)
        })
      },
      utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.12/js/utils.min.js'
    })

    input.addEventListener('countrychange', function () {
      const instance = iti.getSelectedCountryData()

      if (areaCodeInput) {
        areaCodeInput.value = `+${instance.dialCode} (${instance.name})`
      }
    })
  })(window.jQuery)
}, 1500) // this does not seem very clean

/* Disable geoIpOutput */
// var DEBUG = false
// if (!DEBUG) {
//   if (!window.console) window.console = {}
//   var methods = ['log']
//   for (var i = 0; i < methods.length; i++) {
//     console[methods[i]] = function () {}
//   }
// }
